import { View, Text, Platform } from "react-native";
import { GuidePageHeader, GuideCard, GuideStep, GuideTip, GuideNav, getGuideNav } from "./_components";

const PAGE_HREF = "/(web)/guide/photos";

export default function PhotosPage() {
  if (Platform.OS !== "web") return null;
  const nav = getGuideNav(PAGE_HREF);

  return (
    <View>
      <GuidePageHeader
        icon="images"
        title="Foto's"
        subtitle="Deel herinneringen met de familie via de foto galerij. Upload, bekijk, like en reageer!"
        color="#EC4899"
      />

      {/* Familie Galerij */}
      <Text className="text-xl font-bold text-gray-900 mb-4">De Familie Galerij</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        De familie galerij is de plek waar alle gedeelde foto's samenkomen. Hier kun je 
        herinneringen bekijken van het weekend, foto-opdrachten en spontane momenten die 
        familieleden hebben vastgelegd.
      </Text>

      <View className="mb-6">
        <GuideCard
          icon="grid"
          title="Fotoraster"
          description="Alle foto's worden weergegeven in een overzichtelijk raster. Tik op een foto om deze groot te bekijken."
          color="#EC4899"
        />
        <GuideCard
          icon="funnel"
          title="Filters"
          description="Filter foto's op datum, uploader of evenement om specifieke herinneringen terug te vinden."
          color="#3B82F6"
        />
      </View>

      {/* Foto uploaden */}
      <Text className="text-xl font-bold text-gray-900 mb-4 mt-8">Foto's Uploaden</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        Je kunt op meerdere manieren foto's delen met de familie:
      </Text>

      <View className="mb-6">
        <GuideStep
          step={1}
          title="Via de galerij"
          description="Open de familie galerij en tik op de upload-knop. Kies een of meerdere foto's uit je telefoon om te delen."
          color="#EC4899"
        />
        <GuideStep
          step={2}
          title="Via de chat"
          description="Verstuur een foto in een chat. Foto's in chats worden automatisch ook zichtbaar in de galerij."
          color="#EC4899"
        />
        <GuideStep
          step={3}
          title="Via foto-opdrachten"
          description="Bij het insturen van een foto-opdracht wordt je foto ook opgeslagen in de galerij."
          color="#EC4899"
        />
      </View>

      <GuideTip title="Foto kwaliteit">
        Foto's worden geoptimaliseerd voor snelle weergave in de app. De originele kwaliteit 
        wordt behouden wanneer je een foto downloadt.
      </GuideTip>

      {/* Interactie */}
      <Text className="text-xl font-bold text-gray-900 mb-4 mt-8">Likes en Reacties</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        Maak de galerij sociaal door te reageren op foto's van andere familieleden!
      </Text>

      <View className="mb-6">
        <GuideCard
          icon="heart"
          title="Liken"
          description="Tik op het hartje om een foto te liken. Je kunt zien hoeveel likes een foto heeft en wie er heeft geliked."
          color="#EF4444"
        />
        <GuideCard
          icon="chatbubble"
          title="Reageren"
          description="Plaats een reactie onder een foto. Deel een herinnering, compliment of grappige opmerking."
          color="#6366F1"
        />
      </View>

      {/* Downloaden */}
      <Text className="text-xl font-bold text-gray-900 mb-4 mt-8">Foto's Downloaden</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        Wil je een foto bewaren op je telefoon? Je kunt elke foto uit de galerij downloaden:
      </Text>

      <View className="mb-6">
        <GuideStep
          step={1}
          title="Open de foto"
          description="Tik op een foto in de galerij om deze te openen in de grote weergave."
          color="#EC4899"
        />
        <GuideStep
          step={2}
          title="Download"
          description="Tik op het download-icoontje. De foto wordt opgeslagen in je telefoon's fotobibliotheek."
          color="#EC4899"
        />
      </View>

      <GuideTip variant="success" icon="save" title="Herinneringen bewaren">
        Download je favoriete foto's van het weekend om ze voor altijd te bewaren. 
        Na het weekend blijven alle foto's beschikbaar in de app.
      </GuideTip>

      <GuideNav {...nav} />
    </View>
  );
}
